/**
 * @fileoverview Main dashboard layout
 * @description Calm light workspace shell with sidebar (desktop) and top chrome (mobile).
 * @module components/layout/DashboardLayout
 */

import { lazy, Suspense, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { MobileTopChrome, Sidebar } from './Sidebar';
import { useUIStore } from '@/stores/ui';

// The invite form and its validation libraries download the first time the modal opens.
const InviteClientModal = lazy(() =>
  import('@/components/clients/InviteClientModal').then((m) => ({ default: m.InviteClientModal })),
);

export function DashboardLayout(): React.JSX.Element {
  const inviteModalOpen = useUIStore((state) => state.inviteModalOpen);
  const [inviteModalMounted, setInviteModalMounted] = useState(false);
  if (inviteModalOpen && !inviteModalMounted) setInviteModalMounted(true);

  return (
    <div className="flex h-dvh overflow-hidden bg-background text-foreground">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <MobileTopChrome />
        <main className="min-h-0 min-w-0 flex-1 overflow-auto">
          <Suspense
            fallback={
              <div className="flex h-full items-center justify-center">
                <div className="h-8 w-8 animate-spin rounded-full border-2 border-neutral-300 border-t-neutral-800" />
              </div>
            }
          >
            <Outlet />
          </Suspense>
        </main>
      </div>
      {inviteModalMounted ? (
        <Suspense fallback={null}>
          <InviteClientModal />
        </Suspense>
      ) : null}
    </div>
  );
}
